export const pluginReviews = [
	{
		title: "Great plugin and support",
		comment: "The support is excellent and that is what gives extra points to this great plugin!",
		name: "nadine7486",
		profileLink: "https://wordpress.org/support/users/nadine7486/",
		profileImage: "https://secure.gravatar.com/avatar/deec2d560e674e83b393044424ac7d6572baa186f12a875438dd8db0d3cfc36b?s=100&d=retro&r=g",
		link: "https://wordpress.org/support/topic/great-plugin-and-support-555/",
		stars: 5,
	},
	{
		title: "The perfect plugin for WooCommerce Product slider",
		comment: "It has so many customization options! Thanks a lot! Amazing work.",
		name: "Creative Andrew ",
		profileLink: "https://wordpress.org/support/users/geisthanen/",
		profileImage: "https://secure.gravatar.com/avatar/be37c38b5463d12443cb7fab8d3f1dacadc663bca1e938e05b9a9a95e743e3de?s=100&d=retro&r=g",
		link: "https://wordpress.org/support/topic/the-perfect-plugin-for-woocommerce-product-slider/",
		stars: 5,
	},
	{
		title: "Beautiful clean product slider and great support",
		comment: "I tried numerous plugins to achieve a clean look and nice user interface for a laterally sliding product image slider for woocommerce. There is only one that gives the options for customization and really clean appearance. Once you know how to work the settings for product or category query and style settings, operation is very simple. When I have needed some customizing support, I paid the fair price for pro version and got all issues resolved with the knowledgable and kind support at Pick Plugins. Its rare to find a plugin that will do exactly what you want it to do…. I love this plugin!",
		name: "jdougherty2282",
		profileLink: "https://wordpress.org/support/users/jdougherty2282/",
		profileImage: "https://secure.gravatar.com/avatar/6aca2800708efd511dfd8238827bdcfe7291df1dc9a035c48c64bed5b1c8ed1e?s=100&d=retro&r=g",
		link: "https://wordpress.org/support/topic/beautiful-clean-product-slider-and-great-support/",
		stars: 5,
	},
	{
		title: "Wonderful!!",
		comment: "I have been able to do most of what I need to do with the free option of the plugin because there are so many wonderful customization options. I plan to buy the plugin just to spice it up even more!",
		name: "SaraStJohn ",
		profileLink: "https://wordpress.org/support/users/sarastjohn/",
		profileImage: "https://secure.gravatar.com/avatar/3b314ce2e5186e4ece33cf91ff5d076fc23aae45506a4fab34b51d68e4d47721?s=100&d=retro&r=g",
		link: "https://wordpress.org/support/topic/wonderful-466/",
		stars: 5,
	},
	{
		title: "Awesome plugin!",
		comment: "Great job! This plugin works perfect! Thank you.",
		name: "davidzupec",
		profileLink: "https://wordpress.org/support/users/davidzupec/",
		profileImage: "https://secure.gravatar.com/avatar/ff9a15b1f61f559b3c8bfb8960d02b942a68b8e7769e4ae0227d46ec59dd421b?s=100&d=retro&r=g",
		link: "https://wordpress.org/support/topic/awesome-plugin-1882/",
		stars: 5,
	},
	{
		title: "Excellent",
		comment: "Works a treat and painless to use.",
		name: "robgs",
		profileLink: "https://wordpress.org/support/users/robgs/",
		profileImage: "https://secure.gravatar.com/avatar/256edf46bac1000520c31e365e1ff95cec4da037447963fdc94b51d63f2982c3?s=100&d=retro&r=g",
		link: "https://wordpress.org/support/topic/excellent-3579/",
		stars: 5,
	},
	{
		title: "its great!!! easy and comfy",
		comment: "its great !! easy to use, and hebrew support!!.",
		name: "galirimon",
		profileLink: "https://wordpress.org/support/users/galirimon/",
		profileImage: "https://secure.gravatar.com/avatar/c5a98c5e1b81e07217276cde923012577db95ed14125b56da19c88daf16b6fd8?s=100&d=retro&r=g",
		link: "https://wordpress.org/support/topic/its-great-easy-and-comfy/",
		stars: 5,
	},

];
